export default __webpack_public_path__ + "static/media/20201102_175907.ff897e86.jpg";